<template>
  <div
    :class="[
      'rounded-full flex justify-center hover:cursor-pointer py-1 px-2 roboto-mono-400',
    ]">
    <p :class="['select-none font-bold']">{{ formatProtocol(protocol) }}</p>
  </div>
</template>

<script setup>
import { useFormat } from '@/composables/useFormat'

const { formatProtocol } = useFormat()
const props = defineProps({
  progress: String,
  protocol: String
})

const getPillColor = (progress) => {
  switch (progress) {
    case 'VENCENDO HOJE':
      return 'bg-card-blueLight/10 hover:bg-blue-700/25'
    case 'EM EXECUÇÃO':
      return 'bg-card-blueMedium/10 hover:bg-blue-700/25'
    case 'NO PRAZO':
      return 'bg-card-blueDark/10 hover:bg-blue-700/25'
    case 'EMITIDOS NA MADRUGADA':
      return 'bg-card-purpleLight/10 hover:bg-purple-700/25'
    case 'PRIORIDADE 1':
      return 'bg-card-purpleMedium/10 hover:bg-purple-700/25'
    case 'EXPIRA EM 2H':
      return 'bg-card-purpleDark/10 hover:bg-purple-700/25'
    case 'EXPIRA EM 1H':
      return 'bg-card-redLight/10 hover:bg-red-700/25'
    case 'EXECUTADO EM ATRASO':
    case 'EM ATRASO':
      return 'bg-card-redLight/10 hover:bg-red-700/25'
    case 'FORA DO PRAZO':
      return 'bg-card-redMedium/10 hover:bg-red-700/25'
  }
}

const getProtocolClass = (progress) => {
  switch (progress) {
    case 'VENCENDO HOJE':
      return `text-card-blueLight`
    case 'EM EXECUÇÃO':
      return 'text-card-blueMedium'
    case 'NO PRAZO':
      return 'text-card-blueDark'
    case 'EMITIDOS NA MADRUGADA':
      return 'text-card-purpleLight'
    case 'PRIORIDADE 1':
      return 'text-card-purpleMedium '
    case 'EXPIRA EM 2H':
      return 'text-card-purpleDark'
    case 'EXPIRA EM 1H':
      return 'text-card-redLight'
    case 'EXECUTADO EM ATRASO':
    case 'EM ATRASO':
      return 'text-card-redLight'
    case 'FORA DO PRAZO':
      return `text-card-redMedium`
  }
}

</script>
